<div class="corridor-padding">
  <svg id="otpFtpGraphSvg" width="760" height="360"></svg>
</div>
